import { createContext, useContext, useState, type PropsWithChildren } from 'react'

export type BackgroundTheme = 'primary' | number

const AppViewContext = createContext<{
  backgroundTheme?: BackgroundTheme
  setBackgroundTheme: React.Dispatch<React.SetStateAction<BackgroundTheme>>
}>({
  // eslint-disable-next-line i18next/no-literal-string
  backgroundTheme: 'primary',
  setBackgroundTheme: () => {},
})

export default function AppViewContextProvider({
  children,
}: PropsWithChildren<{
  backgroundTheme?: BackgroundTheme
}>) {
  const [backgroundTheme, setBackgroundTheme] = useState<BackgroundTheme>(0)

  return (
    <AppViewContext.Provider
      value={{
        backgroundTheme,
        setBackgroundTheme,
      }}>
      {children}
    </AppViewContext.Provider>
  )
}

export function useAppView() {
  const context = useContext(AppViewContext)

  if (!context) {
    // eslint-disable-next-line i18next/no-literal-string
    throw new Error('useAppView must be used within an AppView')
  }

  return context
}
